export enum ExportOptionValues {
  No = 100000000,
  Yes = 100000001,
}

export enum PregnantOptionValues {
  No = 100000000,
  Yes = 100000001,
}
